import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

import { getDateFnLocale } from '@/utils/formatters'
import { Locale } from 'date-fns'
import { formatDuration } from 'date-fns'
import { Duration } from 'date-fns'
import intervalToDuration from 'date-fns/intervalToDuration'
import { PropType, computed, onMounted, onUnmounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseCountdown',
  props: {
  to: {
    type: Date,
    required: true,
  },
  format: {
    type: Array as PropType<string[]>,
    default: () => [
      'years',
      'months',
      'weeks',
      'days',
      'hours',
      'minutes',
      'seconds',
    ],
  },
  stopIfPast: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props

const i18n = useI18n()



const currentMoment = ref<Date>(new Date())
const isInPast = computed<boolean>(() => {
  return props.to < currentMoment.value
})
const countdownDuration = computed<Duration>(() => {
  return intervalToDuration({
    start: currentMoment.value,
    end: props.to,
  })
})
const locale = computed<Locale>(() => getDateFnLocale())
const formattedDuration = computed<string>(() => {
  return formatDuration(countdownDuration.value, {
    format: props.format,
    locale: locale.value,
  })
})

const formattedText = computed<string>(() => {
  if (isInPast.value) {
    return `${formattedDuration.value} (${i18n.t('countdown.inPast')})`
  }
  return formattedDuration.value
})

const intervalHandler = () => {
  currentMoment.value = new Date()
}

let intervalId: number
onMounted(() => {
  intervalId = setInterval(intervalHandler, 1000)
})
onUnmounted(() => {
  clearInterval(intervalId)
})

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "countdown", {
    now: currentMoment.value,
    to: __props.to,
    duration: _unref(countdownDuration),
    format: __props.format,
    locale: _unref(locale),
    formattedDuration: _unref(formattedDuration),
    formattedText: _unref(formattedText),
    inPast: _unref(isInPast)
  }, () => [
    _createTextVNode(_toDisplayString(_unref(formattedText)), 1)
  ])
}
}

})